/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Page_Training_HintInputs */

const en_us2_profile_page_training_hint = /** @type {(inputs: Profile_Page_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goal, routine, equipment, lifestyle and exclusions`)
};

const pt_br2_profile_page_training_hint = /** @type {(inputs: Profile_Page_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo, rotina, equipamento, estilo de vida e exclusões`)
};

const es_419_profile_page_training_hint = /** @type {(inputs: Profile_Page_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo, rutina, equipo, estilo de vida y exclusiones`)
};

const pt_pt2_profile_page_training_hint = /** @type {(inputs: Profile_Page_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo, rotina, equipamento, estilo de vida e exclusões`)
};

const fr_fr2_profile_page_training_hint = /** @type {(inputs: Profile_Page_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objectif, rythme, matériel, mode de vie et exclusions`)
};

const de_de2_profile_page_training_hint = /** @type {(inputs: Profile_Page_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel, Routine, Ausrüstung, Lebensstil und Ausschlüsse`)
};

const it_it2_profile_page_training_hint = /** @type {(inputs: Profile_Page_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiettivo, routine, attrezzatura, stile di vita ed esclusioni`)
};

/**
* | output |
* | --- |
* | "Goal, routine, equipment, lifestyle and exclusions" |
*
* @param {Profile_Page_Training_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_page_training_hint = /** @type {((inputs?: Profile_Page_Training_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Page_Training_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_page_training_hint(inputs)
	if (locale === "es-419") return es_419_profile_page_training_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_page_training_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_page_training_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_page_training_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_page_training_hint(inputs)
	return en_us2_profile_page_training_hint(inputs)
});
export { profile_page_training_hint as "profile.page_training_hint" }